export default __webpack_public_path__ + "static/media/ic_next_medical.6b5152d3.svg";